import { euGrades, nordicCountries, nordicGrades } from 'src/constants'
import constants from '../../assets/constants.json'

export const createGradesObject = (CCode = 'GB') => {
  if (nordicCountries.includes(CCode)) {
    return nordicGrades.reduce((ob, value) => ((ob[value] = {}), ob), {})
  }

  return euGrades.reduce((ob, value) => ((ob[value] = {}), ob), {})
}

export const createBaseFees = () => {
  return {
    pricing: constants.availableProducts.reduce((agg, prod) => {
      agg[prod] = {}
      return agg
    }, {})
  }
}

export default () => {
  return Object.assign(
    {
      available_countries: [],
      available_products: constants.availableProducts,
      accounts: [],
      custom_fee_dialog: {
        show: false,
        loading: false
      },
      selectedProduct: constants.availableProducts[0],
      selectedCountry: '',
      edit_mode: false,
      view_loading: false,
      raw_response: {},
      modified: false
    },
    createBaseFees()
  )
}
